import { render, staticRenderFns } from "./MantraAdd.vue?vue&type=template&id=beab3734&scoped=true&"
import script from "./MantraAdd.vue?vue&type=script&lang=js&"
export * from "./MantraAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beab3734",
  null
  
)

export default component.exports